<script>
    import NavBar from './navbar.svelte'
    import PhoneInfo from './phone-info.svelte'
    import NavbarText from './navbar-text.svelte'
    import TabBar from './tab-bar.svelte'
    import Selector from './selector.svelte'
    import LinkText from './link-text.svelte'
    import LinkIcons from './link-icons.svelte'
    import BottomButtonBar from '../shared/bottom-button-bar.svelte'

    export let theme
    export let primary
    export let secondary
    export let tertiary
    export let rowIconColor
    export let tabBarHighlightTextColor

    const staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'

    $: backgroundImage = `${staticAssetPrefix}img/onboarding/${
        theme === true ? 'team-background-dark.png' : 'team-background.png'
    }`
</script>

<style>
    .fno-preview {
        width: 414px;
        height: 896px;
        position: relative;
        margin-bottom: 25px;
    }
</style>

<div class="fno-preview" style="background-image: url({backgroundImage});">
    <NavBar fill={primary} />
    <PhoneInfo />
    <TabBar fill={tertiary} />
    <Selector fill={secondary} />
    <NavbarText textFill={tabBarHighlightTextColor} />
    <LinkText fill={theme ? '#FFF' : '#000'} />
    <LinkIcons fill={rowIconColor} />
    <BottomButtonBar fill={primary} />
</div>
